"use client"

import {format} from "date-fns"
import {Calendar as CalendarIcon} from "lucide-react"

import {cn} from "@/lib/utils"
import {Button} from "@/components/ui/button"
import {Calendar} from "@/components/ui/calendar"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover"
import {Label} from "@/components/ui/label.tsx";
export default function DatePicker(props: FieldRenderProps & {label: string}) {
    const date = props.value
    const setDate = (value: any) => { props.onChange(format(value, "yyyy-MM-dd")) }
    console.log(date)

    return (
        <Label className={"w-full"}>
            {props.label}
            <Popover>
                <PopoverTrigger asChild>
                    <Button
                        variant={"outline"}
                        className={cn(
                            "w-full justify-start text-left font-normal",
                            !date && "text-muted-foreground"
                        )}
                    >
                        <CalendarIcon className="mr-2 h-4 w-4"/>
                        {date ? format(date, "yyyy.MM.dd") : <span>Dátum kiválasztása</span>}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0">
                    <Calendar
                        mode="single"
                        selected={date}
                        onSelect={setDate}
                        initialFocus
                    />
                </PopoverContent>
            </Popover>
            <div className={"h-4"}>
                <span className={"text-red-500 text-sm"}>{props.error}</span>
            </div>
        </Label>
    )
}
